export default __webpack_public_path__ + "alberta-place.d58c20a028e90f46d271.svg";